import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Docs from "@/pages/docs/page";
import Signup from "@/pages/signup/page";
import Status from "@/pages/status/page";
import Contacto from "@/pages/contacto/page";
import Privacy from "@/pages/privacy/page";
import Terms from "@/pages/terms/page";
import Security from "@/pages/security/page";
import Precios from "@/pages/precios/page";
import Contadores from "@/pages/contadores/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/docs",
    element: <Docs />,
  },
  {
    path: "/docs/*",
    element: <Docs />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/status",
    element: <Status />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/seguridad",
    element: <Security />,
  },
  {
    path: "/precios",
    element: <Precios />,
  },
  {
    path: "/contadores",
    element: <Contadores />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;